// @flow
import types from "./types";
import {nowInMillseconds} from "../../../Utils/TimeUtil";

const updateProposalData = (proposalData: Object) => {
    return {
        type: types.PROPOSAL_DATA_UPDATE,
        payload: {
            timestamp: nowInMillseconds(),
            ...proposalData,
        },
    };
};

const proposalTimeout = () => ({
    type: types.PROPOSAL_TIMEOUT,
});

export const resetCurrentProposal = () => ({
    type: types.PROPOSAL_DATA_CLEAR,
});

export const acceptProposal = () => ({type: types.PROPOSAL_ACCEPTED});

export default {
    updateProposalData,
    proposalTimeout,
    resetCurrentProposal,
    acceptProposal,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentProposal/actions.js